/**
 * REVIEWS.io Card Carousel: Dot-Navigation unter dem Karussell.
 * Das Widget rendert selbst keine Dots – dieses Script ergänzt sie und hält
 * sie mit dem nativen Scroll des Widgets (.R-ReviewsList) synchron.
 * Styles: reviews-io-carousel-tweaks.css (.rio-carousel-dots).
 */
(function () {
  'use strict';

  function initDots(list) {
    var widget = list.closest('.CarouselWidget');
    if (!widget || widget.querySelector('.rio-carousel-dots')) return;

    var isGerman = (document.documentElement.lang || '').indexOf('de') === 0;
    var wrap = document.createElement('div');
    wrap.className = 'rio-carousel-dots';
    widget.appendChild(wrap);

    var dots = [];

    function cardWidth() {
      var card = list.querySelector('.R-ReviewsList__item');
      return card ? card.clientWidth : 0;
    }

    function update() {
      var width = cardWidth();
      if (!dots.length || !width) return;
      var maxScroll = list.scrollWidth - list.clientWidth;
      var index = maxScroll > 0 && list.scrollLeft >= maxScroll - 2
        ? dots.length - 1
        : Math.round(list.scrollLeft / width);
      index = Math.max(0, Math.min(index, dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function build() {
      var width = cardWidth();
      var count = width ? Math.round((list.scrollWidth - list.clientWidth) / width) + 1 : 0;
      wrap.innerHTML = '';
      dots = [];
      if (count < 2) return;
      for (var i = 0; i < count; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rio-carousel-dots__dot';
          dot.setAttribute('aria-label', (isGerman ? 'Bewertungen, Seite ' : 'Reviews, page ') + (index + 1));
          dot.addEventListener('click', function () {
            list.scrollTo({ left: index * cardWidth(), top: 0, behavior: 'smooth' });
          });
          wrap.appendChild(dot);
          dots.push(dot);
        })(i);
      }
      update();
    }

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', build);
    build();
  }

  // Widget rendert asynchron (AJAX) – auf die Review-Liste warten (max. 30s)
  var tries = 0;
  var timer = setInterval(function () {
    var lists = document.querySelectorAll('.CarouselWidget .R-ReviewsList');
    if (lists.length) {
      clearInterval(timer);
      lists.forEach(initDots);
    } else if (++tries > 300) {
      clearInterval(timer);
    }
  }, 100);
})();
